var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicalError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39895_3968)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E2E6F5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_39895_3968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8688 21.2188L26.5819 54.5881H53.2725L42.7913 21.2188H35.8688Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2725 55.8069H26.5819L25.4119 54.2713L34.6744 20.9019L35.8444 20H42.7669L43.9369 20.8531L54.4181 54.2225L53.2481 55.8069H53.2725ZM28.1906 53.3694H51.5906L41.8894 22.4375H36.7706L28.1906 53.3694Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9775 54.5881H22.2188V57.7813H56.9775V54.5881Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9775 59H22.2188L21 57.7813V54.5881L22.2188 53.3694H56.9775L58.1963 54.5881V57.7813L56.9775 59ZM23.4375 56.5625H55.7588V55.8069H23.4375V56.5625Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7481 28.8238L42.7913 21.2188L43.8394 24.5581L32.2125 34.3081L33.7481 28.8238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4038 53.0769L49.4456 42.4006L50.6156 46.325L43.425 53.0769H38.4038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 46.5931L45.9356 31.2856L47.0325 34.7469L26.9963 53.0769L28.8 46.5931Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39895_3968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_39895_3968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.1963,
    height: 39,
    fill: "white",
    transform: "translate(21 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalError);
export default __webpack_public_path__ + "static/media/technical-error.52c3e0790bfdb2c2e8d9f6f9575fb48e.svg";
export { ForwardRef as ReactComponent };